exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kobo-image{display:flex;flex-direction:row;align-content:center;align-items:center;padding:0;margin:0;min-width:200px;min-height:200px;width:100%;height:100%}.kobo-image__image{max-width:100%;max-height:100%;margin:0 auto}", ""]);

// exports
